import { BarChart, AxisConfig } from '@mui/x-charts';
import { CompetenceStat, CompetenceStatsResponse } from '../OrganizationComponentStats/OrganizationComponentStats.types';
import { useTranslation } from "react-i18next";

const OrganizationComponentStatsCharts = ({competenceStatsResponse}: {competenceStatsResponse: CompetenceStatsResponse}) => {
  const {t} = useTranslation()
  const chartSetting : any = {
    yAxis: [
      {
        label: t("reports.barChartDescription"),
        tickMaxStep: 2,
        tickMinStep: 1
      },
    ],
    height: 300,
  };

  const xAxis: AxisConfig = {id: 'x', scaleType: 'band', dataKey: 'label'}

  const competencies: object[] = [] 
  const series: {dataKey: string, label:string}[] = []
  const compotenceLevelesSet = new Set<string>();
  competenceStatsResponse.competence_stats.map((competenceStat: CompetenceStat) => {
    const compotencyLevels = Object.keys(competenceStat.competence_counts)
    const item: { label: string; [key: string]: number | string } = {label: competenceStat.area_name}

    compotencyLevels.map((competencyLevel) => {
      compotenceLevelesSet.add(competencyLevel)
      item[competencyLevel] = competenceStat.competence_counts[competencyLevel].known_competences
    })

    competencies.push(item)
  })

  for (const item of compotenceLevelesSet) {
    series.push({dataKey: item, label: item.replace(/_/g, " ")})
  }


  return (
    <BarChart
      xAxis={[xAxis]}
      dataset={competencies}
      series={series}
      {...chartSetting}
    />
  )
}

export default OrganizationComponentStatsCharts
